import Http from './http';
import store from 'store';

class ServiceLinesService {
    constructor() {
        this.serviceLines = null;
        this.serviceLinesFlat = null;
    }

    resetCache(){
        if (!(this.serviceLines && this.serviceLinesFlat)) return;
        store.set('serviceLines', false)
        store.set('serviceLinesFlat', false)
        this.serviceLines = null;
        this.serviceLinesFlat = null;
        this.getServiceLines();
    }

    getServiceLines(flat) {
        return new Promise((resolve, reject) => {
            if (store.get('serviceLines', false)){
                this.serviceLines = store.get('serviceLines');
            }
            if (store.get('serviceLinesFlat', false)){
                this.serviceLinesFlat = store.get('serviceLinesFlat');
            }
            if (flat && this.serviceLinesFlat) resolve(this.serviceLinesFlat);
            else if (!flat && this.serviceLines) resolve(this.serviceLines);
            else {
                Http.get('/mapped-taxonomy/Service Lines?flat=' + flat).then(resp => {
                    if (flat){
                        this.serviceLinesFlat = resp.data;
                        store.set('serviceLinesFlat', this.serviceLinesFlat)
                    }
                    else{
                        this.serviceLines = resp.data;
                        store.set('serviceLines', this.serviceLines)
                    }
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new ServiceLinesService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/serviceLines.js